"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));

var _styles = require("./styles");

var _yellowAlert = _interopRequireDefault(require("../../../assets/images/genericModal/yellowAlert.svg"));

var _closeWhite = _interopRequireDefault(require("../../../assets/images/genericModal/closeWhite.svg"));

var _jsxRuntime = require("react/jsx-runtime");

/*
props (* required):
  - *close: function to quit pop up e.g close={() => setShow(!show)}
  - button1/button2: name and action button e.g. button1={{ name: 'Cancelar', action: () => console.log('Cancelar') }}
  - img: source image
  - *message: message to show (like title)
  - detail: message detail
  - withoutImg: if the value is "true" the icon will not be displayed, if this attribute is ignored or has the value of "false" the icon will be displayed
  - customComponent: contains a custom component
*/
var GlobalModal = function GlobalModal(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MainContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MessageContainer, {
      height: props.button1 || props.button2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Header, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
          widthImg: props.widthImg,
          heightImg: props.heightImg,
          children: !props.withoutImg && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
            src: props.img,
            fallbackImage: _yellowAlert.default,
            alt: ""
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Close, {
          onClick: props.close,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _closeWhite.default,
            alt: "Cerrar"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Message, {
        children: [props.bold && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BoldText, {
          children: props.bold
        }), " ", props.message]
      }), props.detail && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Detail, {
        children: "".concat(props.detail, " ")
      }), props.textArea && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextArea, {
        id: "area"
      }), props.customComponent && props.customComponent, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerButtons, {
        children: [props.button1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FirstButton, {
          onClick: props.button1.action,
          children: props.button1.name
        }), props.button2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Button, {
          onClick: props.button2.action,
          children: props.button2.name
        })]
      })]
    })
  });
};

exports.GlobalModal = GlobalModal;